<template>
  <div>
    <el-tabs v-model="obj.activeName" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="持仓" name="first">
        <el-table :data="obj.positionList" style="width: 1200px" :height="obj.height" empty-text=" "
          :cell-style="cellStyle" @row-click="rowClick">
          <el-table-column fixed label="名称" prop="name" width="130px" />
          <el-table-column label="代码" prop="symbol" width="80px" />
          <el-table-column label="交易所" prop="exchange" width="80px" />
          <el-table-column label="多空" prop="direction" width="80px" />
          <el-table-column label="总仓" prop="quantity" width="80px" />
          <el-table-column label="开仓均价" prop="price" width="90px" />
          <el-table-column label="价差" prop="point" width="90px" />
          <el-table-column label="浮盈" prop="float" width="90px" />
          <el-table-column label="保证金" prop="margin" width="90px" />
          <el-table-column label="资金占比" prop="proportion" width="90px" />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="交易记录" name="second">
        <el-table :data="obj.tradeLogList" style="width: 1200px" :height="obj.height" empty-text=" ">
          <el-table-column fixed label="日期" prop="date" width="180px" />
          <el-table-column fixed label="名称" prop="name" width="130px" />
          <el-table-column label="代码" prop="symbol" width="80px" />
          <el-table-column label="交易所" prop="exchange" width="80px" />
          <el-table-column label="操作" prop="direction" width="80px" />
          <el-table-column label="手数" prop="quantity" width="80px" />
          <el-table-column label="价格" prop="price" width="80px" />
          <!-- <el-table-column label="手续费" prop="fee" width="80px" /> -->
          <el-table-column label="平仓盈亏" prop="profit" width="80px" />
          <!-- <el-table-column label="盈亏率" prop="profitRate" width="80px" /> -->
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="obj.total" :current-page="obj.page" class="mt-16"
          @current-change="handlePageChange"></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="收益曲线" name="third">
        <el-select v-model="obj.selectedRangeValue" @change="handleSelectChange" style="width:110px">
          <el-option v-for="item in obj.selectRangeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div id="chart" style="width: 100%" :style="'height:' + (this.$store.state.windowHeight - 400) + 'px'"
          ref="chartDomRef"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from "vue";
import { useStore } from 'vuex'
import { http, httpNoLoading } from "../util/http";
import { isMarketTime } from '../util/base'
import { setCharts } from '../module/line'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const chartDomRef = ref()
    const obj = reactive({
      activeName: 'first',
      positionList: [],
      timer: null,
      height: store.state.windowHeight - 300,
      tradeLogList: [],
      total: 0,
      page: 1,
      limit: 10,
      legendData: [],
      Xdata: [],
      seriesData: [],
      seriesList: [],
      selectRangeList: [
        {
          value: '20',
          label: '最近 1个月'
        },
        {
          value: '40',
          label: '最近 2个月'
        },
        {
          value: '60',
          label: '最近 3个月'
        },
        {
          value: '120',
          label: '最近 半年'
        },
        {
          value: '240',
          label: '最近 一年'
        },
        {
          value: '0',
          label: '全部'
        }
      ],
      selectedRangeValue: '20',
    });

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView();
    });

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      clearInterval(obj.timer)
    })

    // 渲染画面
    const renderView = () => {
      requestData()
      requestTradeLogData()
      clearInterval(obj.timer)
      obj.timer = setInterval(function () {
        // 如不在开盘时间，则停止获取数据
        if (!isMarketTime()) {
          clearInterval(obj.timer)
          return
        }
        requestData()
        requestTradeLogData()
      }, 5000)
    };

    // 后台获取数据
    const requestData = () => {
      httpNoLoading({
        url: `/position`,
        method: 'post',
      }).then((res) => {
        processData(res);
      });
    };

    // 后台获取交易履历
    const requestTradeLogData = () => {
      let formData = new FormData()
      formData.append("page", obj.page)
      formData.append("limit", obj.limit)
      httpNoLoading({
        url: `/trade_log`,
        method: 'post',
        data: formData
      }).then((res) => {
        processTradeLogData(res)
      });
    };

    // 加工处理数据
    const processData = (res) => {
      obj.positionList = res.data.data
      obj.positionList.forEach(element => {
        if (element['direction'] === 1) {
          element['direction'] = '多头'
        } else {
          element['direction'] = '空头'
        }
      })
    };

    // 加工处理数据
    const processTradeLogData = (res) => {
      obj.total = res.data.data[0]
      obj.tradeLogList = res.data.data[1]
      obj.tradeLogList.forEach(element => {
        if (element['direction'] === 1 && element['openClose'] === 1) {
          element['direction'] = '多开'
        } else if (element['direction'] === 1 && element['openClose'] === 0) {
          element['direction'] = '平多'
        } else if (element['direction'] === 0 && element['openClose'] === 1) {
          element['direction'] = '空开'
        } else if (element['direction'] === 0 && element['openClose'] === 0) {
          element['direction'] = '平空'
        }
        if (element['profit'] === '') {
          element['profit'] = '-'
        }
        if (element['profitRate'] === '') {
          element['profitRate'] = '-'
        } else {
          element['profitRate'] = (element['profitRate'] * 100).toFixed(2) + '%'
        }
      })
    };

    // 持仓行选中事件
    const rowClick = (e) => {
      store.commit('setCurrentContract', e.name)
      vueEvent.emit('event', e.name)
    };

    // Tab改变事件
    const handleTabClick = (e) => {
      // console.log(e.props.name)
      if (e.props.name === 'third') {
        requestReturnRateData()
      }
    };

    // 下拉框选择事件
    const handleSelectChange = () => {
      requestReturnRateData()
    }

    // 后台获取收益曲线
    const requestReturnRateData = () => {
      let formData = new FormData()
      formData.append("range", obj.selectedRangeValue)
      http({
        url: `/trade_return`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        processReturnRateData(res)
        var myChart = renderChart()
        setStore(myChart)
      });
    };

    // 加工处理数据
    const processReturnRateData = (res) => {
      obj.legendData = res.data.data[0]
      obj.Xdata = res.data.data[1]
      obj.seriesData = res.data.data[2]
      // renderChart()
    };

    // 绘制图表
    const renderChart = () => {
      obj.seriesList = []
      // console.log(obj.legendData)
      // console.log(obj.Xdata)
      // console.log(obj.seriesData)
      obj.seriesData.forEach((item) => {
        // 设置坐标数据
        let data = item.map((item) => item['data'])
        let name = item.map((item) => item['name'])
        if (name[0] === '动态权益') {
          obj.seriesList.push({
            'name': name[0],
            'type': 'line',
            'data': data,
            // 'smooth': true,
            'showSymbol': true,
            'label': { 'show': true },
            'yAxisIndex': 0,
            'areaStyle': {},
          })
        } else if (name[0] === '日收益率') {
          obj.seriesList.push({
            'name': name[0],
            'type': 'line',
            'data': data,
            // 'smooth': true,
            'showSymbol': true,
            'label': { 'show': true },
            'yAxisIndex': 1,
            itemStyle: {
              normal: {
                color: 'pink', //改变折线点的颜色
                lineStyle: {
                  color: 'orange' //改变折线颜色
                }
              }
            }
          })
        }
      })
      var myChart = setCharts(chartDomRef.value, '', obj.legendData, obj.Xdata, obj.seriesList)
      return myChart
    }

    // 保存至store
    const setStore = (myChart) => {
      store.commit('setMyChart', myChart)
    }

    // 分页变化事件
    const handlePageChange = (value) => {
      obj.page = value
      requestTradeLogData()
    };

    // 表格单元格样式
    const cellStyle = (row) => {
      if (row.row.point > 0 && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.point < 0 && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.float > 0 && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.float < 0 && row.columnIndex === 7) {
        return { color: 'green' }
      }
    };

    return {
      obj,
      store,
      chartDomRef,
      rowClick,
      handleTabClick,
      handlePageChange,
      handleSelectChange,
      cellStyle
    };
  },
};
</script>
<style lang="scss" scoped></style>
